import { api } from "./api";

export const deliveryService = {
  queue: async (params) => (await api.get("/admin/delivery/queue", { params })).data,
};

export const collectionService = {
  queue: async (params) => (await api.get("/admin/collection/queue", { params })).data,
};
